const TimeZones = {
    getTimeZones: function () {
        return [
            {
                name: "America/Anchorage",
                value: "America/Anchorage",
            },
            {
                name: "America/Toronto (Canada/Eastern)",
                value: "America/Toronto",
            },
            {
                name: "Arizona",
                value: "America/Phoenix",
            },
            {
                name: "Atlantic (Canada/Atlantic)",
                value: "America/Halifax",
            },
            {
                name: "America/Winnipeg (Canada/Central)",
                value: "America/Winnipeg",
            },
            {
                name: "America/Edmonton (Canada/Mountain)",
                value: "America/Edmonton",
            },
            {
                name: "Asia/Manila",
                value: "Asia/Manila",
            },
            {
                name: "America/Vancouver (Canada/Pacific)",
                value: "America/Vancouver",
            },
            {
                name: "America/Santiago (Chile/Continental)",
                value: "America/Santiago",
            },
            {
                name: "America/St_Johns (Canada/Newfoundland)",
                value: "America/St_Johns",
            },
            {
                name: "Central (CST6CDT)",
                value: "CST6CDT",
            },
            {
                name: "Eastern (EST5EDT)",
                value: "EST5EDT",
            },
            {
                name: "Hawaii",
                value: "Pacific/Honolulu",
            },
            {
                name: "Mountain (MST7MDT)",
                value: "MST7MDT",
            },
            {
                name: "Northwest Indiana",
                value: "America/Indiana/Knox",
            },
            {
                name: "Pacific (PST8PDT)",
                value: "PST8PDT",
            },
            {
                name: "Saskatchewan (Canada/Saskatchewan)",
                value: "America/Regina",
            },
        ];
    },
};

export default TimeZones;
